import type * as React from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // `bg-muted/40` gives a faint gray-tinted fill that reads on BOTH
        // surfaces: the free shell's white `bg-background` page (where a white
        // `bg-card` field was invisible) AND the embedded platform's light-gray
        // `bg-secondary` canvas. `--card`/`--background` are both pure white, so
        // neither can stand out on the free shell — the muted tint is what makes
        // the field legible regardless of canvas. Border + tint, no drop shadow.
        // Dark mode: `--input`, `--border` and `--secondary` (the embedded
        // canvas) are all the SAME color, so `bg-input` + `border-input` made the
        // field vanish. Use a faint light wash (`dark:bg-white/5`, a raised
        // surface above any dark canvas) and a light border (`dark:border-white/15`)
        // so the field reads regardless of the surrounding token.
        'h-11 w-full min-w-0 rounded-lg border border-input bg-muted/40 px-4 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-ring/60 focus-visible:border-ring focus-visible:bg-background focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:border-white/15 dark:bg-white/5 dark:hover:border-white/25 dark:focus-visible:border-ring dark:focus-visible:bg-white/10 dark:disabled:bg-white/5 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
        className
      )}
      {...props}
    />
  )
}

export { Input }
